<form class="cadastros-edit" ng-submit="edit.saveMaquina($event)" name="maquinaEditForm">
  <span ng-if="edit.isShowing()">
    <h3 ng-show="!edit.maquina">Nova máquina</h3>
    <h3 ng-show="edit.maquina">Editando <i>{{edit.maquina.descricao}}</i></h3>
  </span>
  <div class="row" >
    <div class="col-xs-6">
      <!-- Descricao -->
      <div class="form-group">
        <label for="description" class="control-label">Descrição</label>
        <input type="text" ng-model="edit.editMaquina.descricao" name="description" id="description" required class="form-control" ng-disabled="edit.isShowing()">
      </div>
    </div>
    <div class="col-xs-6">
      <div class="form-group">
        <label for="grupo" class="control-label">Grupo</label>
        <ui-select ng-model="edit.editMaquina.grupo" required name="grupo" id="grupo" ng-disabled="edit.isShowing()">
          <ui-select-match>{{$select.selected.descricao | capitalize}}</ui-select-match>
          <ui-select-choices repeat="grupo in edit.groups | orderBy: 'descricao' | filter: $select.search">
            <span ng-bind-html="grupo.descricao | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-4">
      <div class="form-group">
        <label for="tipo_controle_manutencao" class="control-label">Tipo de Controle</label>
        <select name="tipo_controle_manutencao"
                id="tipo_controle_manutencao"
                ng-model="edit.editMaquina.tipo_controle_manutencao"
                ng-required="!edit.maquina"
                ng-disabled="edit.maquina"
                class="form-control"
                ng-disabled="edit.isShowing()">
          <option value="" disabled>Selecione</option>
          <option value="H">Horímetro</option>
          <option value="K">Quilometragem</option>
        </select>
      </div>
    </div>
    <div class="col-xs-4">
      <div class="form-group">
        <label for="alimentacao" class="control-label">Alimentação</label>
        <select name="alimentacao" id="alimentacao" ng-model="edit.editMaquina.alimentacao" required class="form-control" ng-disabled="edit.isShowing()">
          <option value="N">Nenhuma</option>
          <option value="E">Elétrica</option>
          <option value="C">Combustível</option>
        </select>
      </div>
    </div>
    <div class="col-xs-4">
      <div class="form-group">
        <label for="integracao_gps_id" class="control-label">Código de integração com GPS</label>
        <div class="input-group inline-field">
          <input
            type="text"
            name="integracao_gps_id"
            id="integracao_gps_id"
            class="form-control"
            ng-model="edit.editMaquina.integracao_gps_id"
            ng-disabled="edit.isShowing()"
          >
          <button type="button" class="btn btn-white" title="Ver lista de máquinas" ng-click="edit.openIntegrationMachineModal()" ng-if="!edit.isShowing()">
            <i class="fa fa-external-link"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-4">
      <div class="form-group">
        <label for="capacidade_tanque" class="control-label">Capacidade do tanque</label>
        <small>
          <i class="icon-info text-muted" aria-hidden="true" uib-tooltip="Selecione o grupo de pulverizadores para habilitar esse campo" tooltip-placement="right"></i>
        </small>
        <div class="input-group">
          <input
            type="number"
            ng-disabled ="!edit.editMaquina.grupo.ler_capacidade_tanque"
            name="capacidade_tanque"
            id="capacidade_tanque"
            class="form-control"
            min="0"
            ng-model="edit.editMaquina.capacidade_tanque"
            ng-disabled="edit.isShowing()"
          >
          <span class="input-group-addon">litros</span>
        </div>
      </div>
    </div>
    <div class="col-xs-4">
      <div class="col-xs-6 no-padding-left" ng-if="edit.editMaquina.grupo.ler_capacidade_tanque">
        <div class="form-group">
          <label for="largura_trabalho" class="control-label">Largura de trabalho</label>
          <div class="input-group">
            <input
              type="number"
              name="largura_trabalho"
              id="largura_trabalho"
              class="form-control"
              min="0"
              ng-model="edit.editMaquina.largura_trabalho"
              ng-disabled="edit.isShowing()"
            >
            <span class="input-group-addon">metros</span>
          </div>
        </div>
      </div>
      <div class="col-xs-6 no-padding-left">
        <div class="form-group">
          <label for="st_conjunto" class="control-label">Admite implemento</label>
          <div class="switch">
            <div class="onoffswitch">
              <input type="checkbox"
                     name="st_conjunto"
                     id="st_conjunto"
                     ng-model="edit.editMaquina.st_conjunto"
                     class="onoffswitch-checkbox"
                     ng-disabled="edit.isShowing()">
              <label class="onoffswitch-label" for="st_conjunto">
                <span class="onoffswitch-inner"></span>
                <span class="onoffswitch-switch"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-4" ng-if="edit.maquina && !edit.isShowing()">
      <div class="form-group">
        <label for="inactive" class="control-label">Desativar máquina</label>
        <div class="switch">
          <div class="onoffswitch">
            <input type="checkbox"
                   name="inactive"
                   id="inactive"
                   ng-model="edit.inactive"
                   class="onoffswitch-checkbox"
                   ng-change="edit.toggleActive()">
            <label class="onoffswitch-label" for="inactive">
              <span class="onoffswitch-inner"></span>
              <span class="onoffswitch-switch"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="form-group">
        <label for="propriedades" class="control-label">Propriedades</label>
        <ui-select ng-model="edit.editMaquina.propriedades" required name="propriedades" id="propriedades" multiple>
          <ui-select-match placeholder="Propriedade(s)">{{$item.descricao | capitalize}}</ui-select-match>
          <ui-select-choices repeat="propriedade in $root.propriedades | orderBy: 'descricao' | filter: {descricao: $select.search}">
            <span  class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
  </div>
  <small>* Para uma máquina ser considerada um implemento ela deve estar como "Admite Implemento: Não" e "Alimentação: Nenhuma"</small>
  <hr>
  <div class="row" ng-if="!edit.isShowing()">
    <div class="col-xs-6">
      <button type="button" class="btn btn-danger" ng-click="edit.deleteMaquina()" ng-disabled="edit.loading" ng-if="edit.maquina">
        Apagar
        <i class="fa fa-trash"></i>
      </button>
    </div>
    <div class="col-xs-6 text-right">
      <button type="button" class="btn btn-white" ng-click="edit.cancel()" ng-disabled="edit.loading">Cancelar</button>
      <button type="submit" class="btn btn-success" ng-disabled="maquinaEditForm.$invalid || edit.loading">
        <span ng-show="!edit.loading">
          Salvar
          <i class="fa fa-save"></i>
        </span>
        <i class="fa fa-spinner fa-pulse fa-fw" ng-show="edit.loading"></i>
      </button>
    </div>
  </div>
</form>
